(function postUserConfigurationIIFEWrapper() {
  // ES6 features are eslint-disabled.
  // For some reason application is not built if es6 feature are present.
  const moduleName = 'postUserConfiguration';
  const postUserConfigurationModule = App[moduleName] || {};

  App[moduleName] = (function postUserConfigurationModuleIIFE() {
    // eslint-disable-next-line prefer-destructuring
    const isInternalErrorPage = window.isInternalErrorPage;

    const dataLayerPush = function (details) {
      const userInfo = {
        event: 'errorUserConfigutation',
        value: details,
      };
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      dataLayer.push(userInfo);
    };

    const sendData = function () {
      const supportDetails = {
        referer: document.referrer,
        previousPage: $('.originalUrl').attr('data-originalUrl'),
        jsStatus: window.jQuery && window.App ? 'ENABLED' : 'DISABLED',
        cookieStatus: navigator.cookieEnabled ? 'ENABLED' : 'DISABLED',
        errorStatus: isInternalErrorPage ? '500' : '404',
      };

      if (typeof window.detectPrivateMode === 'function') {
        // eslint-disable-next-line prefer-arrow-callback
        window.detectPrivateMode(function detectPrivateModeCallback(isPrivate) {
          supportDetails.browserMode = isPrivate ? 'ANONIMOUS' : 'STANDARD';
          dataLayerPush(supportDetails);
        });
      } else {
        dataLayerPush(supportDetails);
      }
    };

    const postSupportDetails = function () {
      if (document.readyState !== 'complete') {
        $(window).on('load', sendData);
      } else {
        sendData();
      }
    };

    (function executeOnInternalServerErrorPage() {
      if (isInternalErrorPage) {
        postSupportDetails();
      }
    }());

    $.extend(postUserConfigurationModule, {
      // eslint-disable-next-line object-shorthand
      postSupportDetails: postSupportDetails,
    });

    return postUserConfigurationModule;
  }());
}());
